import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import '../styles/LoginPage.css'
import hdccLogo from '../assets/images/HDCC_logo.ico'
import autodeskLogo from '../assets/images/autodesk.webp'
import bg from '../assets/images/login_bg.webp'

const LoginPage = () => {
  const { login, loading, error, isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const [localError, setLocalError] = useState(null)

  // Auto-redirect if already authenticated
  if (isAuthenticated) {
    navigate('/dashboard', { replace: true })
    return null
  }

  const handleLogin = async () => {
    try {
      setLocalError(null)
      // The login function redirects to Autodesk OAuth, doesn't return here
      await login()
    } catch (err) {
      setLocalError(err.message || 'Failed to initiate authentication. Please try again.')
    }
  }

  return (
    <div className="login-container"
     style={{
      backgroundImage: `url(${bg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh"}}>

      <div className="login-box">
        {/* HDCC Logo */}
        <div className="company-logo-container">
          <img src={hdccLogo} alt="Hawaiian Dredging Construction Company" className="company-logo" />
        </div>

        <h1 className="login-title">Welcome</h1>
        <p className="login-subtitle">Sign in with your Autodesk Account to continue to Approval Aggregator</p>

        {(error || localError) && (
          <div className="error-message">
            {error || localError}
          </div>
        )}

        <button
          onClick={handleLogin}
          disabled={loading}
          className="login-button"
        >
          <img src={autodeskLogo} alt="Autodesk" className="button-icon-img" />
          {loading ? 'Redirecting...' : 'Sign in with Autodesk'}
        </button>

        <div className="login-divider">OR</div>

        <div className="oauth-info">
          <div className="oauth-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L3 6V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V6L12 2Z" fill="#5B8DEF" stroke="#4A7FE5" strokeWidth="1.5"/>
              <path d="M12 8C10.9 8 10 8.9 10 10V11H9V15H15V11H14V10C14 8.9 13.1 8 12 8ZM12 9C12.55 9 13 9.45 13 10V11H11V10C11 9.45 11.45 9 12 9Z" fill="white"/>
            </svg>
          </div>
          <div className="oauth-text">
            <h3>Secure Authentication</h3>
            <p>This application uses OAuth 2.0 for secure authentication. Your credentials are never stored locally.</p>
          </div>
        </div>
      </div>

      {/* Footer - Bottom Right */}
      <div className="login-footer">
        <p>© 2025 Hawaiian Dredging Construction Company, Inc.</p>
        <p>All rights reserved.</p>
      </div>
    </div>
  )
}

export default LoginPage
